import { Fragment, useEffect, useState } from 'react';
import { track } from '../../../../tracking';
import ModalDialog from '../../../common/ModalDialog';
import { IFrameBareDialog } from '../../../common/IFrameDialog';
import { setTemplateFieldIfEmpty } from '../../../../pages/editTemplate/common/utils';
import { getSelectedClinicId } from '../../../../store/idbHandler';
import { NO_FOOTER, NO_HEADER } from '../../../../pages/editTemplate/EditTemplate';
import { randomString } from '../../../../store/utils';
import { RenderPdfPrescription } from '../../../../Templar/RenderPdfPrescription';
import { getFooter, getHeader } from '../../../../pages/editTemplate/common/RxTemplatePdfView';
import { renderToStaticMarkup } from 'react-dom/server';
import { DentalExamination } from '../../../../store/types/prescription';
import uniq from 'lodash/uniq';
import { DoctorProfile } from '../../../../api/fetchMyProfile';
import { DFormEntity } from '../../../../api/fetchDoctorGenieByOID';
import { TemplateV2 } from '../../../../Templar/types';

export const MISSING_TEETH_IDS = new Set([
    's-9432460454',
    's-3814050963',
    's-3085925966',
    's-2679364994',
    's-152331861',
]);
export const MISSING = 'missing';

export const IMPLANT_TEETH_IDS = new Set([
    's-3842617059',
    's-734890705',
    's-4746232608',
    's-4809091620',
    's-6539103499',
    's-6539043920',
    's-6538894960',
    's-2828779275',
    's-2828630321',
    's-2827706801',
    's-2828749488',
    's-2828660107',
    's-2827855750',
    's-2828600528',
    's-2828838854',
    's-2827736587',
    's-2828570736',
    's-2826991811',
    's-2827915334',
    's-2828719696',
]);
export const IMPLANT = 'implant';

export const SMALL_TEETH = new Set(['5', '6', '7', '8']);
export const UPPER_TEETH = new Set(['1', '2', '5', '6']);
export const CUSTOM_CLASS_IDS = new Set([MISSING, IMPLANT]);

// Used images: fracture, crack, veneer, carious-exposure-pulp, facet-abfraction, tooth-abrasion, amalgam, caries-decay-cavity, crown, denture, impacted-tooth, restoration-filling
// Unused images: root-canal, pits-fissures, root, dead-tooth

export const EXAMINATIONS_TO_IMAGES: { [k: string]: string } = {
    's-4612148288': 'caries-decay-cavity',
    's-6003831386': 'caries-decay-cavity',
    's-5219931146': 'caries-decay-cavity',
    's-417661515': 'caries-decay-cavity',
    's-3816732146': 'caries-decay-cavity',
    's-1923659586': 'carious-exposure-pulp',
    's-4984136621': 'carious-exposure-pulp',
    's-7385250247': 'carious-exposure-pulp',
    's-7385190668': 'carious-exposure-pulp',
    's-2140329892': 'carious-exposure-pulp',
    's-569970504': 'tooth-abrasion',
    's-4468708188': 'impacted-tooth',
    's-2168005676': 'fracture',
    's-366589825': 'fracture',
    's-7300750309': 'crown',
    's-7300690730': 'restoration-filling',
    's-7300839680': 'amalgam',
    's-7327502625': 'denture',
    's-7327472833': 'denture',
    's-7325774750': 'denture',
    's-7325685380': 'denture',
    's-3570561519': 'denture',
    's-7327740951': 'denture',
    's-7373036246': 'denture',
    's-7325864125': 'denture',
    's-7326787642': 'denture',
    's-7328426148': 'denture',
    's-817534133': 'denture',
    's-4863668733': 'denture',
    's-7326579111': 'denture',
    's-7326608895': 'denture',
    's-7327651585': 'denture',
    's-4863638938': 'denture',
    's-4831166749': 'denture',
    's-7327621793': 'denture',
    's-7327681372': 'denture',
    's-7325804542': 'denture',
    's-2766116389': 'facet-abfraction',
    's-7300780105': 'veneer',
    's-7302776101': 'veneer',
    's-7302746305': 'veneer',
    's-7302805884': 'veneer',
    's-7303461288': 'veneer',
    's-7303491080': 'veneer',
    's-7302716518': 'veneer',
    's-7324821433': 'veneer',
    's-7324702278': 'veneer',
    's-7304414607': 'veneer',
    's-7301673832': 'veneer',
    's-7304563557': 'veneer',
    's-817444763': 'veneer',
    's-2765460987': 'crack',
    's-2765431193': 'crack',
    's-2765401407': 'crack',
};

const LS_KEY_FEATURE_DENTAL_CHART_NEW_UPDATE = 'feature/dental-chart-new-update-v3';
export const DentalChartNewUpdateBanner: React.FC = () => {
    const [isStrip, setisStrip] = useState(
        localStorage.getItem(LS_KEY_FEATURE_DENTAL_CHART_NEW_UPDATE),
    );
    const [showVideo, setShowVideo] = useState(false);

    // const tellMeMore = () => {
    //     track('TELL_ME_MORE_DENTAL_CHART_NEW_UPDATE');
    //     setShowVideo(true);
    // };

    const onClose = () => {
        localStorage.setItem(LS_KEY_FEATURE_DENTAL_CHART_NEW_UPDATE, 'false');
        setisStrip('false');
        track('CROSS', {
            element: 'feature/dental-chart-new-update strip',
        });
    };

    if (isStrip === 'false') {
        return null;
    }

    return (
        <Fragment>
            <div className="relative mt-12 mb-6 -space-y-1">
                <div
                    className="w-20 h-20 border border-darwin-neutral-800 flex items-center justify-center rounded-full absolute -right-8 -top-8 z-10 bg-white cursor-pointer"
                    onClick={onClose}
                >
                    <svg
                        className="w-8 h-12 fill-darwin-neutral-1000"
                        viewBox="0 0 8 9"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M7.5625 7.28906C7.77344 7.52344 7.77344 7.875 7.5625 8.08594C7.32812 8.32031 6.97656 8.32031 6.76562 8.08594L4 5.29688L1.21094 8.08594C0.976562 8.32031 0.625 8.32031 0.414062 8.08594C0.179688 7.875 0.179688 7.52344 0.414062 7.28906L3.20312 4.5L0.414062 1.71094C0.179688 1.47656 0.179688 1.125 0.414062 0.914062C0.625 0.679688 0.976562 0.679688 1.1875 0.914062L4 3.72656L6.78906 0.9375C7 0.703125 7.35156 0.703125 7.5625 0.9375C7.79688 1.14844 7.79688 1.5 7.5625 1.73438L4.77344 4.5L7.5625 7.28906Z" />
                    </svg>
                </div>
                <div className="px-16 py-12 space-x-8 font-lato text-14 font-400 text-white flex items-center justify-between bg-darwin-neutral-800 rounded-8">
                    <p>
                        🦷 New Dental Upgrades Are Now Live! : Experience effortless multi-tooth
                        selections and seamless chart printing on demand! 🚀
                    </p>
                    {/* <button
                        className="border-b-2 border-dotted flex items-center space-x-8"
                        onClick={tellMeMore}
                    >
                        <span className="font-700 whitespace-nowrap">Tell me more!</span>
                    </button> */}
                </div>
                <svg
                    className="ml-14 w-13 h-11"
                    viewBox="0 0 13 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M6.5 9L0.870834 0.75H12.1292L6.5 9Z" fill="#505775" />
                </svg>
            </div>
            {showVideo && (
                <ModalDialog>
                    <IFrameBareDialog
                        url={
                            'https://www.youtube.com/embed/VmupaqqwRQ8?si=d4tyAG34l74P8uyn&autoplay=1&mute=1'
                        }
                        id="dental_chart"
                        closeMe={() => setShowVideo(false)}
                        style={{ width: '720px', height: '476px' }}
                    />
                </ModalDialog>
            )}
        </Fragment>
    );
};

export const DENTAL_CHART_CONTENT = 'dental-chart-content';
export const DENTAL_CHART_CONTAINER = 'dental-chart-container';

export const getDentalChartContent = (): string | undefined => {
    let dentalChartContent = document.getElementById(DENTAL_CHART_CONTENT)?.innerHTML;
    if (!dentalChartContent) return;
    dentalChartContent = dentalChartContent.replaceAll('#19A66A', '#BABABA');
    dentalChartContent = dentalChartContent.replaceAll('#D1EDE1', '#19A66A');
    dentalChartContent = dentalChartContent.replaceAll('overflow-x-auto', 'overflow-x-hidden');
    dentalChartContent = dentalChartContent.replaceAll(
        'ant-checkbox-wrapper',
        'ant-checkbox-wrapper hidden',
    );
    dentalChartContent = dentalChartContent.replaceAll(
        'text-white bg-darwin-accent-bright-blue-800',
        'selected-tooth',
    );
    return dentalChartContent;
};

export const getHeaderAndFooterContent = (
    docData: DoctorProfile,
    prescriptionId: string,
    ptFormDets: DFormEntity[],
): {
    headerHtml: string;
    footerHtml: string;
} => {
    const selectedClinic = getSelectedClinicId();
    const doctorTemplateData = docData?.profile?.professional?.templates_v2;
    const templateData = doctorTemplateData?.find(
        (data) => data.clinicId === selectedClinic && data.type === 'PRINT',
    );
    const renderPdfConfig = setTemplateFieldIfEmpty(
        templateData
            ? {
                  ...templateData,
                  header_img:
                      templateData.header_img && templateData.header_img != NO_HEADER
                          ? `${templateData.header_img}?cacheoff=${randomString(4)}`
                          : templateData.header_img,
                  footer_img:
                      templateData.footer_img && templateData.footer_img != NO_FOOTER
                          ? `${templateData.footer_img}?cacheoff=${randomString(4)}`
                          : templateData.footer_img,
                  attachment_image: templateData.attachment_image
                      ? `${templateData.attachment_image}?cacheoff=${randomString(4)}`
                      : templateData.attachment_image,
              }
            : templateData,
    ) as TemplateV2;
    const headerHtml = getHeader(docData, ptFormDets, renderPdfConfig, undefined, selectedClinic);
    const footerHtml = getFooter(
        docData,
        { id: prescriptionId } as RenderPdfPrescription,
        undefined,
        renderPdfConfig,
    );
    return {
        headerHtml: renderToStaticMarkup(headerHtml),
        footerHtml: renderToStaticMarkup(footerHtml),
    };
};

export const getVisualExaminations = (
    dentalExaminations: DentalExamination[] | undefined,
): string[] => {
    const visualExaminations = uniq(
        dentalExaminations?.map((i) => EXAMINATIONS_TO_IMAGES[i.id])?.filter(Boolean),
    );
    const examinationIds = Array.from(new Set(dentalExaminations?.map((i) => i.id)));
    for (let i = 0; i < examinationIds.length; i++) {
        const id = examinationIds[i];
        if (MISSING_TEETH_IDS.has(id)) {
            visualExaminations.push(MISSING);
            break;
        }
    }
    for (let i = 0; i < examinationIds.length; i++) {
        const id = examinationIds[i];
        if (IMPLANT_TEETH_IDS.has(id)) {
            visualExaminations.push(IMPLANT);
            break;
        }
    }
    return visualExaminations;
};
